// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iframeembed-module_iframeembed_bB1iik6og6x50HA2aNhi iframe{max-width:100%}", "",{"version":3,"sources":["webpack://./src/bloks/articlepanels/iframeembed/iframeembed.module.scss"],"names":[],"mappings":"AACA,4DACE,cAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~cx-web-themes/crunchyroll/abstracts/main\";\n.iframeembed iframe {\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframeembed": "iframeembed-module_iframeembed_bB1iik6og6x50HA2aNhi"
};
export default ___CSS_LOADER_EXPORT___;
